import { FC } from 'react';

import { useChangePassword } from '../hooks/useChangePassword';
import { ChangePasswordView } from '../views/ChangePasswordView';

export type ChangePasswordContainerProps = {};

export const ChangePasswordContainer: FC<ChangePasswordContainerProps> = () => {
  const {
    isOpenVerificationDialog,
    formError,
    passwordValidationRule,
    submitLoading,
    onSubmit,
    onCloseVerificationDialog,
  } = useChangePassword();

  return (
    <ChangePasswordView
      initialErrors={formError}
      isOpenVerificationDialog={isOpenVerificationDialog}
      passwordValidationRule={passwordValidationRule}
      submitLoading={submitLoading}
      onCloseVerificationDialog={onCloseVerificationDialog}
      onSubmit={onSubmit}
    />
  );
};
